<footer class="footer"><div class="content has-text-centered"><p>© 2020-2021 Naumcho by Creative Cells AD</p></div></footer>